<template>
  <router-link to="/settings#beta-access" class="flex items-start gap-2.5 px-4 py-3 hover:bg-gray-700 duration-300">
    <span class="mt-1.5 h-2 w-2 flex-shrink-0 rounded-full bg-danger-700" />
    <span class="flex flex-col gap-0.5">
      <span class="text-sm font-medium text-text-primary">Beta access on</span>
      <span class="text-xs text-text-secondary">You get new features before everyone else.</span>
      <span class="text-xs text-text-primary underline">Manage in Settings</span>
    </span>
  </router-link>
</template>
